import { render } from "./Filler.vue?vue&type=template&id=25f67c70&scoped=true"
import script from "./Filler.vue?vue&type=script&lang=ts"
export * from "./Filler.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-25f67c70"

export default script
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput});
